import { Spinner } from "@aqar-app/react-ui";
import withLazyLoad from "../../../hooks/withLazyLoad";
import css from "./.module.scss";
import usePubDecision from "@/hooks/usePubDecision";

const ImpressionImg = ({ url }) => {
  return (
    <img
      src={url}
      style={{
        display: "none",
      }}
      alt="Impression"
    />
  );
};

const AdSpacesV2 = ({ listingId, adTypes }) => {
  const LazyImpressionImg = withLazyLoad(ImpressionImg);
  const { loading, decision } = usePubDecision({
    listingId,
    adTypes,
  });

  const { contents } = decision || {};
  const { third_party_impression_tracking_url: trackingUrl } =
    contents?.[0]?.data?.customData || {};

  if (loading) {
    return null;
    return (
      <div className={css.AdSpaces}>
        <div className={css.holder}>
          <Spinner />
        </div>
      </div>
    );
  }

  return (
    <div>
      {decision?.contents?.map((content, i) => (
        <a
          key={i}
          href={decision?.clickUrl}
          rel="nofollow"
          target="_blank"
          title=""
        >
          <img
            src={content?.data?.imageUrl}
            style={{
              borderRadius: "5px",
            }}
            alt="Ad Space"
          />
        </a>
      ))}
      {decision?.impressionUrl && (
        <LazyImpressionImg url={decision?.impressionUrl} />
      )}
      {trackingUrl && (
        <LazyImpressionImg
          url={trackingUrl.replace(
            "ord=[timestamp]",
            `ord=${Math.floor(new Date().getTime() / 1000)}`,
          )}
        />
      )}
    </div>
  );
};

export default AdSpacesV2;
